module.exports = {
    common: {
        no_access: '您没有访问权限'
    },
    ChanceBoard: {
        department: '部门',
        sales_user_id: '销售员',
        query: '查询',
        Show_chance_distribution: '显示机会分布',
        Show_sales_funnel: '显示漏斗数据',
        chance_cnt: '机会数量',
        win_amount: '成单金额',
        win_number: '成单数',
        fail_number: '失败数',
        level_rise: '级别上升',
        level_decline: '级别下降',
        follow_number: '跟进客户',
        create_chance: '创建机会',
        created_in_30_days: '30日创建',
        no_follow_in_30_days: '30日未跟进',
        no_follow_in_60_days: '60日未跟进',
        no_level_up_30_days: '30日无提升',
        has_quote_in_30_days: '30日有报价',
        has_contract_in_30_days: '30日有合同',

    },
    quote: {
        select_contacts: '选择联系人',
        effective_to: '有效期至',
        select_quotation_template: '选择报价模板',
        preview_template: '预览模板',
        add_line: '添加商品行',
        trade_name: '商品名称',
        unit: '单位',
        standard_price: '标准价',
        minimum_price: '最低价',
        tax_rate: '税率',
        sales_price: '销售价',
        discount_ratio: '折扣比例%',
        number: '数量',
        remark: '商品名称备注',
        select_item: '选择商品名称',
        quote_remark: '报价备注',
        tax_amount: '税额',
        total_amount_including_tax: '含税总金额',
        amount_not_taxed: '未税金额',
        template_extension_variable: '模板扩展变量',
        please_select: '请选择',
        submit: '提交',
        price_tips: '当前价格低于最低价，需审核',
        template_preview: '模板预览',
        template_tips: '请选择模板',
        get_failed: '获取失败',
        failed_to_get_product_catalog: '获取产品目录失败',
        contact_cannot_be_empty: '联系人不能为空',
        valid_until_cannot_be_empty: '有效期至不能为空',
        commodity_data_cannot_be_empty: '商品数据不能为空',
        quotation_template_cannot_be_empty: '报价模板不能为空',
        failed_to_get_quotation_template: '获取报价模板失败',
        failed_to_get_contact: '获取联系人失败',
        failed_to_get_product: '获取商品失败',
        quotation_data_cannot_be_empty: '报价数据不能为空',
        submission_failed: '提交失败',
        submitted_successfully: '提交成功',
        the: '第',
        product_name_cannot_be_empty: '个商品名称不能为空',
        unit_cannot_be_empty: '个单位不能为空',
        market_price_cannot_be_empty: '个标准价不能为空',
        tax_rate_cannot_be_empty: '个税率不能为空',
        sales_price_cannot_be_empty: '个销售价不能为空',
        discount_ratio_cannot_be_empty: '个折扣比例不能为空',
        cnt_cannot_be_empty: '个数量不能为空',
        select_quote_no: '选择报价单号',
        quote_no_cannot_be_empty: '报价单号不能为空'
    },
    contract: {
        contract_remark: '合同备注',
        select_contract_template: '选择合同模板',
        contract_template_cannot_be_empty: '合同模板不能为空',
    },
    exam: {
        catalog: '知识技能类别',
        question_type: '题型',
        score: '每题分值',
        question_number: '题目数量',
        level: '难度'
    },
    makeSchedule: {
        visualization: '生产可视化',
        wujianPlan: '物件计划',
        planAchievement: '计划&实绩',
        processProduce: '加工生产信息',
        processCalendar: '加工日历',
        tuZhuangProduce: '涂装生产信息',
        paintingCalendar: '涂装日历',
        zuLiProduce: '组立生产信息',
        assemblyCalendar: '组立日历',
        shipmentSchedule: '出货进度',
        assemblyEach: '组立生产进度',
        assemblyProcessShipmentArea: '加工组立出货生产面积进度',
        assemblyProcessShipmentWeight: '加工组立出货生产重量进度',
        finishedProductStorage: '完成品入库信息',
        visualizationPage: {
            wujianId: '物件番号',
            floor: '楼层',
            noZk: '未展开',
            zking: '展开中',
            zkEnd: '展开完了',
            sczsEnd: '生产指示完了',
            jgEnd: '加工完了',
            tzEnd: '涂装完了',
            zzEnd: '组装完了',
            chEnd: '出荷完了',
            louMian: '楼面',
        },
        wujianPlanPage: {
            wujianId: '物件番号',
            jgPlan: '加工计划',
            jgAchievements: '加工实绩',
            tzPlan: '涂装计划',
            tzAchievements: '涂装实绩',
            zlPlan: '组立计划',
            zlAchievements: '组立实绩',
            wujianName: '物件名称',
            floor: '楼层',
            xxFloor: '先行楼层',
            jieyu: '结余',
            weight: '重量(KG)',
            num: '单元数量',
            area: '面积(㎡)',
            jgProgress: '加工进度',
            tzProgress: '涂装进度',
            zlProgress: '组立进度',
            chProgress: '出荷进度',
        },
        planAchievementPage: {
            wujianSelect: '物件选择',
            wujianName: '物件名称',
            cutProduction: '切断产量（KG）',
            jgProduction: '加工产量（KG）',
            accumulated : '社内累计',
            cutJgProductive: '切断加工生产性',
            productionWeight: '生产重量',
            directLabor: '直接人工',
            indirectLabor: '间接人工',
            directProductivity: '直接生产性',
            targetProductivity: '目标生产性',
            totalProductivity: '总生产性',
            jgAchievements: '加工生产实绩',
            jgActualAchievements: '加工实际(kg)',
            jgAccumulatedAchievements: '累计实际(kg)',
            plan: '计划',
            actualAchievements: '实绩',
            accumulatedPlan: '累计计划',
            accumulatedAchievements: '累计实绩',
        },
        processCalendarPage: {
            todayIn: '今日在岗工人',
            inWujian: '在生产物件',
            cutDayProduction: '切断日产量',
            jgDayProduction: '加工日产量',
            bai: '白'
        },
        tzProducePage: {
            wujianSelect: '物件选择',
            wujianName: '物件名称',
            tzProduction: '涂装产量(KG)',
            qcl: '前处理',
            tzArea: '涂装面积(㎡)',
            area: '面积(㎡)',
            totalArea: '累计面积(㎡)',
            tzQclAchievements: '涂装前处理实绩',
            plan: '计划',
            achievements: '实绩',
            totalPlan: '累计计划',
            totalAchievements: '累计实绩',
            tzAchievements: '涂装喷涂生产实绩'
        },
        tzCalendarPage: {
            todayIn: '今日在岗工人',
            inWujian: '在生产物件',
            qclWeight: '前处理重量',
            qclArea: '前处理面积',
            ptWeight: '喷涂重量',
            ptArea: '喷涂面积'
        },
        zlProduceActualPage: {
            wujianSelect: '物件选择',
            wujianName: '物件名称',
            zlProductionWujian: '组立产量-物件别',
            production: '产量',
            zlProductionDay: '组立产量-日产线',
            zlAchievementsCnt: '组立生产月计划-实绩（单元数）',
            zlAchievementsSchedulingCnt: '组立排产计划-实绩（单元数）',
            totalCnt: '累计数',
            zlAchievementsArea: '组立生产月计划-实绩（面积）',
            zlAchievementsSchedulingArea: '组立排产计划-实绩（面积）',
            plan: '生产计划',
            planScheduling: '排产计划',
            achievements: '实绩',
            totalPlan: '累计计划',
            totalAchievements: '累计实绩',
            zlProductivity: '组立生产性',
            productivity: '生产性',
            hour: '工数',
            area: '面积(㎡)',
            area1: '面积',
            totalArea: '累计面积(㎡)',
            targetProductivity: '目标生产性',
            achievementsProductivity: '实绩生产性',
            totalProductivity: '累计生产性',
        },
        assemblyCalendarPage: {
            todayIn: '今日在岗工人',
            inWujian: '在生产物件',
            dayProduction: '日产量',
            kgLine: '开工产线'
        },
        shipmentSchedulePage: {
            shipProgress: '出货进度 单位(㎡)',
            shipTarget: '出货目标',
            achievements: '实绩',
            plan: '计划',
            difference: '差异',
            achievementRate: '达成率'
        },
        assemblyEachUnitNumPage: {
            productionSchedule: '组立物件生产进度 单位(套)',
            plan: '计划',
            achievements: '实绩'
        },
        assemblyProcessShipmentAreaPage: {
            cutProductionSchedule: '切断组立出货生产进度 单位(㎡)',
            plan: '计划',
            achievements: '实绩'
        },
        assemblyProcessShipmentWeightPage: {
            cutProductionSchedule: '切断组立出货生产进度 单位(t)',
            plan: '计划',
            achievements: '实绩'
        },
        processProductionSchedulingCalendar: {
            productionScheduleCalendar: '排产日历',
            todayDetails: '当日详情',
            batchManagement: '批量管理',
            onlyModifyTheWeek: '只修改周',
            dayShift: '白班',
            nightShift: '夜班',
            one: '一',
            two: '二',
            three: '三',
            four: '四',
            five: '五',
            six: '六',
        },
        MfgAttLineScheduleForm: {
            productionLineName: '产线名称',
            timeName: '时间组名称',
            workTime: '工作时间',
            startTime: '开始时间',
            endTime: '结束时间',
            addRest: '添加休息',
            restRemark: '休息备注',
            deleteRest: '删除休息',
            restTime: '休息时间'
        },
        paintingProductionScheduling: {
            batchQuery: '批号查询',
            thisWeek: '本周',
            lastWeek: '上周',
            afterWeek: '下周',
            colorTips: '颜色提示',
            processingNotCarriedOut: '加工未进行',
            processingInProgress: '加工进行中',
            processingCompleted: '加工已完成',
            version: '版本',
            versionNumber: '版本号'
        },
        mfgWuJianInfoEdit: {
            mian: '楼面',
            floor: '楼层',
            wujianEdit: '物件信息编辑',
            setUnit: '设置出货单元',
            lineSetting: '产线设置如下'
        },
        mfgMaterialConfirm: {
            stockType: '存货类型',
            modelType: '型号类型',
            type: 'タイプ',
            glass: '玻璃',
            onlyDisplayShortageInventory: '仅显示缺料存货',
            inventoryCode: '存货编码',
            inventoryName: '存货名称',
            total: '总计',
            inventory: '库存',
            plannedDeliveryQuantity: '计划到货数量',
            orderNo: '订单号',
            orderArrivalDate: '订单到货日期',
            latestEstimatedDate: '最新预计日期'
        },
        AssemblyProductionScheduling: {
            todayProduction: '当日生产',
            todayProductionScheduling: '今日排产',
            yesterday: '截止昨日',
            batchNo: '批号计划',
            oneClickProductionScheduling: '一键排产',
            oneClickClean: '全清除',
            oneClickMove: '右移动',
            exportPicture: '导出图片',
        },
        mfgProcessReportDetail: {
            cutTotalWeight: '切断总重量(KG)',
            sdCutWeight: '手动切断重量(KG)',
            jgTotalWeight: '加工总重量(KG)',
            snJgTotalWeight: '社内加工总重量(KG)',
            sdJgTotalWeight: '手动加工重量(KG)',
            totalLabor: '总人工',
        },
        mfgAssemblyReportDetail: {
            personResponsible: '责任人',
            totalArea: '总面积(㎡)',
            oneLine: '一线',
            twoLine: '二线',
            threeLine: '三线',
            fourLine: '四线',
            fiveLine: '五线',
            sixLine: '六线',
            lineWai: '线外',
            batchNo: '批号',
            unitNo: '单元号',
            floor: '楼层',
            area: '面积(㎡)',
        },
        processProduceAchievement: {
            plan: '计划',
            achievements: '实绩',
            xiangCi: '项次',
            totalWorker: '总人工（含间接）',
        },
    },
}